import PropTypes from 'prop-types'
import StatusIndicator from '../StatusIndicator'
import {
  Td,
  ActionsCell,
  TdNarrowCenter,
  DateTimeCell,
  DateText,
  TimeText,
  ContractTypeCellVertical,
  ContractTypeSmallLabel,
  ContactCell,
  ContactNameText,
  ContactEmailText,
  ContactIdCell,
  CountryFlagWrap,
  IdTopLine,
  IdBottomLine,
  ContactTd,
  ContractTypeTd,
} from './styled-components'
import ActionRowComponent from './ActionRowComponent'
import EditableCell from '@/containers/DevToolsNew/EditableCell'

const ContactsRow = ({ row, t }) => {
  const ContractTypeIcon = row.ContractTypeIcon || null
  const CountryFlagIcon = row.countryFlagIcon || null
  const [createdDate, createdTime] = String(row.createdAtText || '').split(' ')
  const [updatedDate, updatedTime] = String(row.updatedAtText || '').split(' ')

  return (
    <tr>
      <TdNarrowCenter title={row.contactIdTitle}>
        <ContactIdCell>
          {CountryFlagIcon && (
            <CountryFlagWrap>
              <CountryFlagIcon size={16} />
            </CountryFlagWrap>
          )}

          <div>
            <IdTopLine>{row.contactIdText}</IdTopLine>
            <IdBottomLine title={row.contractIdTitle}>{row.contractIdText}</IdBottomLine>
          </div>
        </ContactIdCell>
      </TdNarrowCenter>

      <ContactTd>
        <ContactCell>
          <ContactNameText>
            {row.firstnameText} {row.lastnameText}
          </ContactNameText>
          <ContactEmailText>{row.emailText}</ContactEmailText>
        </ContactCell>
      </ContactTd>

      <ContractTypeTd>
        <ContractTypeCellVertical>
          {ContractTypeIcon && <ContractTypeIcon size={26} />}
          <ContractTypeSmallLabel>{row.contractTypeText}</ContractTypeSmallLabel>
        </ContractTypeCellVertical>
      </ContractTypeTd>

      <Td>{row.prestationTypeText}</Td>

      <Td>
        <StatusIndicator
          variant={row.statusVariant}
          text={row.statusText}
          hasContract={row.hasContract}
          noContractText={t('contacts.no_contract')}
        />
      </Td>

      <Td>
        {row.onUpdateProviderExternalId ? (
          <EditableCell
            value={row.providerExternalIdText !== '-' ? row.providerExternalIdText : ''}
            onSave={row.onUpdateProviderExternalId}
          />
        ) : (
          row.providerExternalIdText
        )}
      </Td>

      <Td>
        <DateTimeCell>
          <DateText>{createdDate || '-'}</DateText>
          <TimeText>{createdTime || ''}</TimeText>
        </DateTimeCell>
      </Td>

      <Td>
        <DateTimeCell>
          <DateText>{updatedDate || '-'}</DateText>
          <TimeText>{updatedTime || ''}</TimeText>
        </DateTimeCell>
      </Td>

      <ActionsCell>
        <ActionRowComponent row={row} t={t} />
      </ActionsCell>
    </tr>
  )
}

ContactsRow.propTypes = {
  row: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
}

export default ContactsRow
